import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '@/store/index';

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    redirect: '/procesos/Index'
  },
  {
    path: '/',
    redirect: '/procesos/Index'
  },
  {
    path: '/procesos/Bienvenida',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Bienvenido'
    }
  },
  {
    path: '/procesos/Index',
    name: 'MenuMain',
    component: () => import('../views/MenuMain.vue'),
    meta: {
      hideVolverConsulta: true,
      title: 'Inicio'
    }
  },
  {
    path: '/procesos/menu-acceso',
    name: 'MenuAccesos',
    component: () => import('../views/acceso/MenuAccesos.vue'),
    meta: {
      title: 'Menu acceso'
    }
  },
  {
    path: '/procesos/NombreRazonSocial',
    name: 'ConsultaRazonSocial',
    component: () => import('../views/MainNombre.vue'),
    meta: {
      title: 'Consulta de Procesos por Nombre o Razón Social'
    }
  },
  {
    path: '/procesos/ConstruirNumeroRadicacion',
    name: 'ConstruirNumero',
    component: () => import('../views/MainConstruirNumero.vue'),
    meta: {
      title: 'Consulta de Procesos Construir Número de Radicación'
    }
  },
  {
    path: '/procesos/NumeroRadicacion',
    name: 'NumeroRadicacion',
    component: () => import('../views/MainRadicacion.vue'),
    props: true,
    meta: {
      title: 'Consulta de Procesos por Número de Radicación'
    }
  },
  {
    path: '/procesos/ConsultaIdentificacion',
    name: 'ConsultaIdentificacion',
    component: () => import('../views/MainIdentificacion.vue'),
    meta: {
      title: 'Consulta de Procesos por Número de Identificación'
    },
    beforeEnter: (to, from, next) => {
      let guards = ['VerCedulas', 'Admin', 'Pruebas'];
      if ( !store.getters['auth/getUserRoles'] || !store.getters['auth/getUserRoles'].some(el => guards.includes(el))) next({ name: 'Menu' })
      else next()
    }
  },
  {
    path: '/details-process/:id',
    name: 'DetailsProcess',
    component: () => import('../views/process/ProcessDetails.vue'),
    meta: {
      title: 'Detalles de Procesos'
    }
  },
  {
    path: '/procesos/Jueces',
    name: 'Jueces',
    component: () => import('../views/MainJuez.vue'),
    meta: {
      title: 'Consulta de Procesos por Jueces'
    }
  },
  {
    path: '/procesos/JuezClaseProceso',
    name: 'Juzgados',
    component: () => import('../components/process/Juzgados.vue'),
    meta: {
      title: 'Consulta de Procesos por Juez Magistrado y Clase de Proceso'
    }
  },
  {
    path: '/procesos/seguimiento-procesos',
    name: 'SeguimientoProcesos',
    component: () => import('../views/process/SeguimientoProcesos.vue'),
    meta: {
      title: 'Seguimiento de Procesos'
    },
    beforeEnter: (to, from, next) => {
      let guards = ['SeguimientoProcs', 'Admin', 'Pruebas'];
      if ( !store.getters['auth/getUserRoles'] || !store.getters['auth/getUserRoles']
        .some(el => guards.includes(el))) {
          next({ name: 'Menu' })
      }
      else {
        next()
      }
    }
  },
  {
    path: '/acceso/entidades',
    name: 'MainAccesoEntidades',
    component: () => import('../views/acceso/MainAccesoEntidades.vue'),
    meta: {
      title: 'Administración de Entidades'
    },
    beforeEnter: (to, from, next) => {
      let guards = ['Admin', 'Pruebas'];
      if ( !store.getters['auth/getUserRoles'] || !store.getters['auth/getUserRoles']
        .some(el => guards.includes(el))) {
          next({ name: 'Menu' })
      }
      else {
        next()
      }
    }
  },
  {
    path: '/acceso/entidad/:id?',
    name: 'MainAccesoEntidad',
    component: () => import('../views/acceso/MainAccesoEntidad.vue'),
    props: true,  // pass route.params to props 
    meta: {
      title: 'Administración de Una Entidad'
    },
    beforeEnter: (to, from, next) => {
      let guards = ['Admin', 'Pruebas'];
      if ( !store.getters['auth/getUserRoles'] || !store.getters['auth/getUserRoles']
        .some(el => guards.includes(el))) {
          next({ name: 'Menu' })
      }
      else {
        next()
      }
    }
  },
  {
    path: '/acceso/usuarios',
    name: 'MainAccesoUsuarios',
    component: () => import('../views/acceso/MainAccesoUsuarios.vue'),
    meta: {
      title: 'Administración de Usuarios'
    },
    beforeEnter: (to, from, next) => {
      let guards = ['Admin', 'Pruebas'];
      if ( !store.getters['auth/getUserRoles'] || !store.getters['auth/getUserRoles']
        .some(el => guards.includes(el))) {
          next({ name: 'Menu' })
      }
      else {
        next()
      }
    }
  },
  {
    path: '/login/menu-signin',
    name: 'MenuSigning',
    component: () => import('../views/login/MenuSigning'),
    meta: {
      hideVolverConsulta: false,
      islogin : true,
      title: 'Menu Inicio de Sesión'
    }
  },
  {
    path: '/login/signin',
    name: 'Signin',
    component: () => import('../views/login/Signin.vue'),
    meta: {
      hideVolverConsulta: false,
      islogin : true,
      title: 'Iniciar Sesión'
    }
  },
  {
    path: '/login/registro-usuario-token/:id?',
    name: 'MainAccesoUsuario',
    component: () => import('../views/acceso/MainAccesoUsuario'),
    props: true,  // pass route.params to props 
    meta: {
      hideVolverConsulta: false,
      islogin : true,
      title: 'Registrar Usuario'
    }
  },
  {
    path: '/login/token',
    name: 'SigninToken',
    component: () => import('../views/login/SigninToken'),
    meta: {
      hideVolverConsulta: false,
      islogin : true,
      title: 'Iniciar Sesión con Token'
    }
  },
{
    path: '/procesos/AccesoInformacion',
    name: 'AccesoInformacion',
    component: () => import('../views/MainAccessInformation.vue'),
    meta: {
      title: 'Acceso a la Información'
    },
    beforeEnter: (to, from, next) => {
      let guards = ['ResultSets', 'Admin'];
      if ( !store.getters['auth/getUserRoles'] || !store.getters['auth/getUserRoles'].some(el => guards.includes(el))) next({ name: 'Menu' })
      else next()
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title + '- Consejo Superior de la Judicatura ' : 'Consejo Superior de la Judicatura'
  next(true)
})

export default router
